import { useSelector } from 'react-redux';
import styled from '@emotion/styled/macro';
import { Box, Heading } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

import BasisSetup from './BasisSetup';
import ItemFormStep from 'components/itemCreationWizard/ItemFormStep';
import SubItemMethodDecisionStep from 'components/itemCreationWizard/SubItemMethodDecisionStep';
import GenericAssetWorkflowStep from 'components/itemCreationWizard/GenericAssetWorkflowStep';
import MoveToItemPageStep from 'components/itemCreationWizard/MoveToItemPageStep';
import BatteryStorageCustomSubItemStep from 'components/itemCreationWizard/CustomSubItemCreation/Battery/BatteryStorageCustomSubItemStep';
import PromptWrapper from '../components/utils/PromptWrapper';
import RenewablesCustomSubItemStep from 'components/itemCreationWizard/CustomSubItemCreation/Renewables/RenewablesCustomSubItemStep';

const ItemCreationWizard = () => {
    const { steps, currentStep } = useSelector((state) => state.itemCreationWizard);
    const hasUnsavedChanges = useSelector((state) => state.helpers.hasUnsavedChanges);

    return (
        <MainWrapper>
            {currentStep !== steps.basisSetupStep && (
                <CenteredWrapper>
                    <Heading as="h1" variant="h1" mt={10}>
                        <FormattedMessage id="item_creation_wizard_heading" />
                    </Heading>
                </CenteredWrapper>
            )}
            {currentStep === steps.itemFormStep && <ItemFormStep />}
            {currentStep === steps.basisSetupStep && <BasisSetup />}
            {currentStep === steps.subItemMethodDecisionStep && <SubItemMethodDecisionStep />}
            {currentStep === steps.subItemGenericAssetStep && <GenericAssetWorkflowStep />}
            {currentStep === steps.subItemBatteryCustomStep && <BatteryStorageCustomSubItemStep />}
            {currentStep === steps.subItemRenewablesCustomStep && <RenewablesCustomSubItemStep />}
            {currentStep === steps.moveToItemPageStep && <MoveToItemPageStep />}
            <PromptWrapper
                when={hasUnsavedChanges}
                header={<FormattedMessage id="common_discard_changes" />}
                content={<FormattedMessage id="common_confirmation_explanation" />}
            />
        </MainWrapper>
    );
};

const MainWrapper = styled(Box)`
    position: fixed;
    top: 80px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin-bottom: 100px;
    padding-bottom: 10px;
`;

const CenteredWrapper = styled(Box)`
    width: 100%;
    max-width: 1314px;
    margin: 0 auto;
    padding: 0 16px;
`;

export default ItemCreationWizard;
